import { render } from "./CreatePartnerCategory.vue?vue&type=template&id=06bf0b03"
import script from "./CreatePartnerCategory.vue?vue&type=script&lang=js"
export * from "./CreatePartnerCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__